'use client';

import * as React from 'react';
export const ResizablePanelContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") ResizablePanelContext.displayName = "ResizablePanelContext";
export function useResizablePanelContext() {
  const context = React.useContext(ResizablePanelContext);
  if (context === undefined) {
    throw new Error('MUI X: Missing context. ResizablePanel subcomponents must be placed within a <ResizablePanel /> component.');
  }
  return context;
}